// extracted by mini-css-extract-plugin
export default {"LineClamped":"LineClamped-styles__LineClamped__LXF8s"};